export default __webpack_public_path__ + "static/media/les_stamp.4b10ab7d.svg";